export const photoURLs = {
  stripeBadge:
    "https://firebasestorage.googleapis.com/v0/b/cyno-telephysio-pilot.appspot.com/o/stripeBadge%2Fpowered_by_stripe%402x.png?alt=media&token=60e6f4d0-2e86-481f-bdcb-bb3f99004f0c",
  verificationEmailClickAnimation:
    "https://firebasestorage.googleapis.com/v0/b/cyno-telephysio-pilot.appspot.com/o/animations%2FEmail-click-gimp-1.gif?alt=media&token=6bc0b827-3885-48fa-b8a0-690a54e5ea34"
};

export const constants = {
  color: {
    primaryDark: "#3FA9B4",
    primary: "#43c3cf",
    primaryLight: "#7FD9E3",
    secondaryDark: "#75600C",
    secondary: "#FFCC00",
    secondaryLight: "#FCDC58",
    grey75: "#404040",
    grey54: "#747474",
    grey34: "#848484",
    grey5: "#F2F2F2",
    dark: "rgba(0,0,0, 0.6)",
    light: "rgba(255, 255, 255, 0.8)"
  },
  layout: {
    InteractionPanel: {
      maxWidth: 542
    },
    ListPanel: {
      minWidth: 358
    },
    container: {
      alignContent: "center",
      display: "flex",
      flex: 1,
      flexDirection: "column",
      justifyContent: "center"
    },
    contentWidth: {
      maxWidth: 1200,
      width: "93vw"
      // paddingRight: 60,
      // paddingLeft: 60
    },
    contentWidthSmall: {
      paddingLeft: 10,
      paddingRight: 10
    },
    breakpoint: {
      break1: 700
    },
    pageMargin: 60,
    sectionTopBottomMargins: {
      marginBottom: 0,
      paddingBottom: 40,
      paddingTop: 40
    },
    shadows: {
      dropShadow: "-5px -1px 20px 0px rgba(0,0,0,0.1)",
      dropShadowAlt: "2px 5px 20px 0px rgba(0,0,0,0.1)"
    }
  },
  text: {
    baseFontStyles: {
      fontFamily: "'Open Sans', sans-serif",
      fontSize: 16
    },
    secondaryFontStyles: {
      fontFamily: "'Nunito', sans-serif",
      fontSize: 16
    },
    displayFont: {
      fontFamily: "'Roboto', sans-serif",
      fontSize: 24
    }
  },
  option: {
    provinces: [
      { value: "NL", label: "Newfoundland and Labrador" },
      { value: "PE", label: "Prince Edward Island" },
      { value: "NS", label: "Nova Scotia" },
      { value: "NB", label: "New Brunswick" },
      { value: "QC", label: "Quebec" },
      { value: "ON", label: "Ontario" },
      { value: "MB", label: "Manitoba" },
      { value: "SK", label: "Saskatchewan" },
      { value: "AB", label: "Alberta" },
      { value: "BC", label: "British Columbia" },
      { value: "YT", label: "Yukon" },
      { value: "NT", label: "Northwest Territories" },
      { value: "NU", label: "Nunavut" }
    ],
    months: [
      { value: 1, label: "January", dayCount: 31 },
      { value: 2, label: "February", dayCount: 29 },
      { value: 3, label: "March", dayCount: 31 },
      { value: 4, label: "April", dayCount: 30 },
      { value: 5, label: "May", dayCount: 31 },
      { value: 6, label: "June", dayCount: 30 },
      { value: 7, label: "July", dayCount: 31 },
      { value: 8, label: "August", dayCount: 31 },
      { value: 9, label: "September", dayCount: 30 },
      { value: 10, label: "October", dayCount: 31 },
      { value: 11, label: "November", dayCount: 30 },
      { value: 12, label: "December", dayCount: 31 }
    ],
    serviceModuleTypes: [
      // IS THIS EVEN USED ANYWHERE
      "Video Consultation",
      "Chat Messaging",
      "Follow-up Consultation",
      "Custom Action Plan/Program",
      "Educational Videos"
    ],
    taxExemptStatus: [
      {
        value: false,
        label: `Provider has a GST/HST # and is not a member of a tax exempt profession`
      },
      {
        value: true,
        label: `Provider's profession is tax exempt. Provider has no GST/HST #`
      }
    ]
  }
};

export const utils = {
  toDateString: timestamp => {
    const dateTime = new Date(timestamp);
    const dateString = dateTime.toISOString(); // Returns "2013-05-31T11:54:44.000Z"
    const dateTimeSplit = dateString.split("T");
    return dateTimeSplit[0];
  },
  toTimestamp: date => {
    const splitDate = date.split("-");
    const year = splitDate[0];
    const month = splitDate[1];
    const day = splitDate[2];

    const datum = new Date(Date.UTC(year, month - 1, day));
    return datum.getTime();
  },
  toWeekDayName: date => {
    const splitDate = date.split("-");
    const year = splitDate[0];
    const month = splitDate[1];
    const day = splitDate[2];

    const datum = new Date(Date.UTC(year, month - 1, day));
    const days = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday"
    ];
    const dayNumber = datum.getDay(); // Monday is first day of the week for this method
    return days[dayNumber];
  }
};

// const localDomain = 'http://localhost:3000';
// const testDomain = 'https://cyno-corporate-test.firebaseapp.com';
const liveDomain = "https://corporate.cyno.ca";

export const activeDomain = liveDomain;

// const testLinkURL = `https://us-central1-cyno-corporate-test.cloudfunctions.net`;
// const prodLinkURL = `https://us-central1-cyno-corporate.cloudfunctions.net`;

// export const httpTriggerBaseURL = prodLinkURL;

export const stripePublicLiveKey = "pk_live_J6lhQMXUtk1OGO4AjbRRS7v0";
export const stripePublicTestKey = "pk_test_pHskuGov2YorT0NTaVnrHFIE";



// WEBPACK FOOTER //
// ./src/js/constants/index.ts